import React from 'react';
import { Input } from 'antd';

const IntegerDecimalInput = ({ maxLength = 5, placeholder, onChange, ...rest }) => {
    const handleKeyDown = (e) => {
        const { key, target } = e;

        // Allow control keys
        if (
            key === 'Backspace' ||
            key === 'Tab' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Delete'
        ) {
            return;
        }

        // Only allow one "."
        if (key === '.' && target.value.includes('.')) {
            e.preventDefault();
        }

        // Block anything other than digits and "."
        if (!/[0-9.]/.test(key)) {
            e.preventDefault();
        }
    };

    const handleChange = (e) => {
        let value = e.target.value;

        // Clean input
        value = value
            .replace(/[^0-9.]/g, '')       // remove invalid
            .replace(/(\..*)\./g, '$1');   // allow only one "."

        // Limit to 2 decimal places if "." present
        if (value.includes('.')) {
            const [intPart, decPart] = value.split('.');
            value = intPart + (decPart !== undefined ? '.' + decPart.slice(0, 2) : '');
        }

        if (onChange) {
            onChange({ target: { value } });
        }
    };

    return (
        <Input
            type="text"
            inputMode="decimal"
            maxLength={maxLength}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            placeholder={placeholder}
            {...rest}
        />
    );
};

export default IntegerDecimalInput;
